import * as React from 'react'
import PropTypes from 'prop-types'

interface AssuranceLocaleProps extends React.SVGProps<SVGSVGElement> {
  strokeColor?: string
}

const AssuranceLocale: React.FC<AssuranceLocaleProps> = ({ strokeColor }) => {
  return (
  <svg width="25" height="25" viewBox="0 0 25 25" 
  className={strokeColor}
  fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.8221 14.5938H18.3294C18.0231 14.5938 17.7211 14.6627 17.4473 14.7951L15.322 15.823C15.0481 15.9554 14.7461 16.0243 14.4399 16.0243H13.3547C12.3051 16.0243 11.4542 16.8473 11.4542 17.8625C11.4542 17.9034 11.4823 17.9396 11.523 17.9508L14.1678 18.6818C14.6423 18.8128 15.1503 18.7672 15.5916 18.5536L17.8637 17.455M11.4542 17.1946L6.67361 15.7266C5.82613 15.4626 4.91004 15.7755 4.37916 16.5103C3.99533 17.0416 4.15161 17.8024 4.71083 18.1249L12.5336 22.6361C13.0311 22.923 13.6182 22.993 14.1654 22.8307L20.8221 20.8565" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M17.7096 7.34476V5.68158C17.7096 4.742 17.7096 4.2722 17.4758 3.96569C17.2419 3.65918 16.7132 3.51038 15.6556 3.21277C14.9331 3.00944 14.2962 2.76448 13.7874 2.54085C13.0935 2.23595 12.7467 2.0835 12.5013 2.0835C12.2559 2.0835 11.9091 2.23595 11.2153 2.54085C10.7064 2.76448 10.0695 3.00944 9.34698 3.21277C8.28946 3.51038 7.76069 3.65918 7.52683 3.96569C7.29297 4.2722 7.29297 4.742 7.29297 5.68158V7.34476C7.29297 10.5675 10.2228 12.5011 11.6876 13.2665C12.039 13.45 12.2146 13.5418 12.5013 13.5418C12.788 13.5418 12.9636 13.45 13.315 13.2665C14.7798 12.5011 17.7096 10.5675 17.7096 7.34476Z" strokeWidth="2" strokeLinecap="round"/>
</svg>

  )
}
AssuranceLocale.propTypes = {
  fill: PropTypes.string,
}
export default AssuranceLocale
